import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './BlogFooter.module.scss';

import KickLogoWhite from 'images/footer-icon.png';
import GreyIG from 'images/footer-ig.png';
import GreyYt from 'images/footer-yt.png';
import GreyFb from 'images/footer-fb.png';
import GreyTt from 'images/footer-tt.png';
import AppDownload from 'images/app-download.png';
import GooglePlayWhite from 'images/googleplaywhite.png';
import AppStoreWhite from 'images/appstorewhite.png';

import { IBlogFooterProps } from './BlogFooter.definition';

function BlogFooter({}: IBlogFooterProps) {
  function redirectSocialMedia(url: string) {
    window.open(url, '_blank');
  }

  function openPlayStore() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.kickavenue.androidshop&hl=in',
      '_blank',
    );
  }

  function openAppStore() {
    window.open(
      'https://apps.apple.com/id/app/kickavenue-shop-collectibles/id1478394222',
      '_blank',
    );
  }

  if (window.screen.availWidth < 480) {
    return (
      <div className={Styles['wrapper-mobile']}>
        <div className={Styles['footer-logo']}>
          <p className={Styles['footer-logo-title']}>
            <span className={Styles['bold']}>KICKAVE</span>
            NEWS
          </p>
          <div className={Styles['footer-logo-img']}>
            <p className={Styles['by']}>by</p>
            <KickImage alt="Kick Avenue Logo" src={KickLogoWhite} />
          </div>
        </div>
        <div className={Styles['footer-option']}>
          <a href="/kickavenews/latest">Latest</a>
          <a href="/kickavenews/calendar">Calendar</a>
          <a className="mb-0" href="/">
            Shop
          </a>
        </div>
        <div className={Styles['explore-us']}>
          <div className={Styles['explore-title']}>
            <h4>Explore us more on Instagram!</h4>
          </div>
          <div className={Styles['explore-options']}>
            <a
              href="https://www.instagram.com/kickavenue.streetwear/"
              target="_blank"
              className={Styles['explre-option']}
            >
              <KickImage alt="" src={GreyIG} />
              <h5>
                Kick Avenue <span>Streetwear</span>
              </h5>
            </a>
            <a
              href="https://www.instagram.com/kickavenue_luxury/"
              target="_blank"
              className={Styles['explre-option']}
            >
              <KickImage alt="" src={GreyIG} />
              <h5>
                Kick Avenue <span>Luxury</span>
              </h5>
            </a>
            <a
              href="https://www.instagram.com/kickavenue.lifestyle/"
              target="_blank"
              className={Styles['explre-option']}
            >
              <KickImage alt="" src={GreyIG} />
              <h5>
                Kick Avenue <span>Lifestyle</span>
              </h5>
            </a>
          </div>
        </div>
        <div className={Styles['keep-in-touch']}>
          <div className={Styles['keep-in-touch-title']}>
            <h5>Keep in touch with us!</h5>
          </div>
          <div className={Styles['social-icons']}>
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://instagram.com/kick.avenue')
              }
              src={GreyIG}
              alt="instagram"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia(
                  'https://www.youtube.com/channel/UCxLcZeJaQuGicSpDBmAug6g',
                )
              }
              src={GreyYt}
              alt="youtube"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.facebook.com/kickavenueid/')
              }
              src={GreyFb}
              alt="facebook"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.tiktok.com/@kickavenue?')
              }
              src={GreyTt}
              alt="tik tok"
            />
          </div>
        </div>
        <div className={Styles['download-app']}>
          <div className={Styles['image-download']}>
            <KickImage src={AppDownload} alt="phone download image" />
          </div>
          <div className={Styles['call-to-action']}>
            <div>
              <h5>Download Our App</h5>
            </div>
            <div className={Styles['img-download-button']}>
              <KickImage
                onClick={() => openPlayStore()}
                style={{ marginBottom: '10px' }}
                src={GooglePlayWhite}
                alt="google play"
              />
              <KickImage
                onClick={() => openAppStore()}
                src={AppStoreWhite}
                alt="apple store"
              />
            </div>
          </div>
        </div>
        <div className={Styles['registered']}>
          <h5>
            Registered under{' '}
            <span>PT. Karunia Internasional Citra Kencana</span>
          </h5>
        </div>
      </div>
    );
  }

  return (
    <div className={Styles['wrapper']}>
      <div className={Styles['nav-footer']}>
        <div className={Styles['kick-logo']}>
          <p className={Styles['kick-avenews-title']}>
            <span className={Styles['bold']}>KICKAVE</span>
            NEWS
          </p>
          <div className={Styles['logo-row']}>
            <p className={Styles['by']}>by</p>
            <KickImage src={KickLogoWhite} alt="" />
          </div>
        </div>
        <div className={Styles['kick-option']}>
          <a href="/kickavenews/latest">Latest</a>
          <a href="/kickavenews/calendar">Calendar</a>
          <a className="mb-0" href="/">
            Shop
          </a>
        </div>
        <div className={Styles['kick-social-child']}>
          <h2>Explore us more on Instagram!</h2>
          <a
            href="https://www.instagram.com/kickavenue.streetwear/"
            target="_blank"
          >
            <KickImage src={GreyIG} alt="" />
            <p>
              Kick Avenue <span>Streetwear</span>
            </p>
          </a>
          <a
            href="https://www.instagram.com/kickavenue_luxury/"
            target="_blank"
          >
            <KickImage src={GreyIG} alt="" />
            <p>
              Kick Avenue <span>Luxury</span>
            </p>
          </a>
          <a
            href="https://www.instagram.com/kickavenue.lifestyle/"
            target="_blank"
          >
            <KickImage src={GreyIG} alt="" />
            <p>
              Kick Avenue <span>Lifestyle</span>
            </p>
          </a>
        </div>
        <div className={Styles['kick-social']}>
          <h2>Keep in touch with us!</h2>
          <div>
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://instagram.com/kick.avenue')
              }
              src={GreyIG}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia(
                  'https://www.youtube.com/channel/UCxLcZeJaQuGicSpDBmAug6g',
                )
              }
              src={GreyYt}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.facebook.com/kickavenueid/')
              }
              src={GreyFb}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.tiktok.com/@kickavenue?')
              }
              src={GreyTt}
              alt=""
            />
          </div>
        </div>
        <div className={Styles['kick-app-img']}>
          <KickImage src={AppDownload} alt="" />
        </div>
        <div className={Styles['kick-download']}>
          <h2>Download Our App</h2>
          <div>
            <KickImage onClick={() => openPlayStore()} src={GooglePlayWhite} alt="" />
            <KickImage onClick={() => openAppStore()} src={AppStoreWhite} alt="" />
          </div>
        </div>
      </div>
      <div className={Styles['registered']}>
        <h4>
          Registered under <span>PT. Karunia Internasional Citra Kencana</span>
        </h4>
      </div>
    </div>
  );
}

export default BlogFooter;
